import React,{useState} from 'react';
import Sidebar from '../components/Sidebar';
// import Navbar2 from '../components/Navbar2';
import Navbar from '../components/Navbar';



import Footer from '../components/Footer';
import Sroll from '../components/Scroll';
import Galleryimg from '../components/Gallery';

function GalleryPage() {
    const [isOpen,setIsOpen]= useState(false);
    const toggle= ()=>{
        setIsOpen(!isOpen);
    }
    return (
        <>
         <Sidebar isOpen={isOpen} toggle={toggle} />
         <Navbar toggle={toggle} /> 
         <Galleryimg />
         
         <Sroll />
         <Footer />
        </>
    )
}

export default GalleryPage